import React from 'react'

import Img from 'components/base/Img'
import Title from 'components/base/Title'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import ButtonRow from 'components/base/Button/Row'

import SIG from 'assets/images/michael-sig.svg'

import {
  SubpageSection,
  OurStoryWrap,
  QuoteText,
  TeamMemberName,
  TeamMemberTitle,
  Signature,
} from './styles'

const OurStory: React.FC = (): React.ReactElement => (
  <OurStoryWrap>
    <SubpageSection>
      <Title level={2}>Our Story</Title>
      <QuoteText>
        Insurance Lounge is the culmination of an idea whose sole purpose is making Insurance easier to purchase and understand for consumers.
        With a heavy emphasis on technology and simplicity, Insurance Lounge will pave a new way for consumers to interact online and in our storefronts
        by creating a truly interactive Insurance experience.
      </QuoteText>
      <Signature>
        <Img src={SIG} src2x={undefined} alt='Michael Signature' />
      </Signature>
      <TeamMemberName>Michael DeLaGrange</TeamMemberName>
      <TeamMemberTitle>Founder &amp; CEO</TeamMemberTitle>
      <ButtonRow>
        <Link theme={LinkTheme.button} to='/about-us/our-story/'>
          Read Our Story
        </Link>
      </ButtonRow>
    </SubpageSection>
  </OurStoryWrap>
)

export default OurStory
